import { DateTime } from 'luxon';
import { apiRequest } from './apiClient';

type DeviceSessionApiResponse = {
    id: number;
    device: string;
    ip_address: string | null;
    location: string | null;
    last_activity_at: string | null;
    created_at: string;
    current: boolean;
};

type SessionsApiResponse = {
    sessions: DeviceSessionApiResponse[];
};

export type DeviceSession = {
    id: number;
    browser: string;
    os: string;
    timeAgo: string;
    location: string;
    isCurrentDevice: boolean;
};

function parseDevice(device: string): { browser: string; os: string } {
    const idx = device.indexOf(', ');
    if (idx === -1) return { browser: device, os: '' };
    return { browser: device.slice(0, idx), os: device.slice(idx + 2) };
}

function relativeTime(isoString: string | null): string {
    if (!isoString) return 'some time ago';
    return DateTime.fromISO(isoString).toRelative({ locale: 'en' }) ?? 'some time ago';
}

function mapSession(s: DeviceSessionApiResponse): DeviceSession {
    const { browser, os } = parseDevice(s.device);
    return {
        id: s.id,
        browser,
        os,
        timeAgo: relativeTime(s.last_activity_at),
        location: s.location ?? s.ip_address ?? 'Unknown location',
        isCurrentDevice: s.current,
    };
}

export const getSessions = async (): Promise<DeviceSession[]> => {
    const response = await apiRequest<SessionsApiResponse>('/api/sessions', 'GET');
    return response.sessions.map(mapSession);
};

export const signOutSession = async (id: number): Promise<void> => {
    await apiRequest<{ message: string }>(`/api/sessions/${id}`, 'DELETE');
};
